export const GetUserDetails = async (graphqlService, variables) => {
    const GET_USER_DETAILS_QUERY = `
        query GetUserDetails($userId: Float!) {
            getUserDetails(userId: $userId) {
                id
                personalEmail
                profilePicture
                firstName
                lastName
                businessName
                roleType
                primaryContactNumber
                secondaryContactNumber
                emergencyContact
                jobTitle
                location
                department
                startDate
                tradesPosterEmail
                abn
                businessName
                companyName
                serviceCategory {
                    id
                    name
                }
                userRoles {
                    id
                    name
                }
                userPlan {
                    id
                    userId
                    planId
                    trialEndDate
                    startDate
                    subscriptionEndDate
                    isTrialActive
                    isPaidActive
                    plan {
                        name
                    }
                }
            }
        }
    `;
    try {
        const response = await graphqlService.fetchData(GET_USER_DETAILS_QUERY, variables);
        return response;
    } catch (error) {
        console.error("Query Error:", error);
        throw error;
    }
}; 